require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-landgoed-ottermeer.json") })
        }
      }, "path---projecten-landgoed-ottermeer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-landgoed-ottermeer!./.cache/json/projecten-landgoed-ottermeer.json
// module id = 427
// module chunks = 231608221292675